"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IaKind = void 0;
/**
 * IaKind represents the specific IA article subtype (aka. ArtikelTyp in iPro / `IAArtikeltyp`)
 */
var IaKind;
(function (IaKind) {
    IaKind["Abstandhalter"] = "Abstandhalter";
    IaKind["Einsteckboden"] = "Einsteckboden";
    IaKind["Fachboden"] = "Fachboden";
    IaKind["Hoehenschlitzsteg"] = "Hoehenschlitzsteg";
    IaKind["HoehenschlitzstegOffen"] = "HoehenschlitzstegOffen";
    IaKind["KlemmRasttrennsteg"] = "KlemmRasttrennsteg";
    IaKind["Klemmteilungssteg"] = "Klemmteilungssteg";
    IaKind["Klemmtrennsteg"] = "Klemmtrennsteg";
    IaKind["KlemmtrennstegAsymetrisch"] = "KlemmtrennstegAsymetrisch";
    IaKind["KlemmtrennstegHoehenschlitz"] = "KlemmtrennstegHoehenschlitz";
    IaKind["Rasttrennsteg"] = "Rasttrennsteg";
    IaKind["Seitenplatte"] = "Seitenplatte";
    IaKind["Teilungssteg"] = "Teilungssteg";
    IaKind["Trennsteg"] = "Trennsteg";
    IaKind["TrennstegAsymetrisch"] = "TrennstegAsymetrisch";
    IaKind["TrennstegFuerMitteloeffnungsteg"] = "TrennstegFuerMitteloeffnungsteg";
    IaKind["TrennstegGeschlitzt"] = "TrennstegGeschlitzt";
    IaKind["TrennstegMitZwischenboden"] = "TrennstegMitZwischenboden";
    IaKind["Universalboden"] = "Universalboden";
    IaKind["Universalraststeg"] = "Universalraststeg";
    IaKind["Universalsteg"] = "Universalsteg";
    IaKind["Zugentlastungstrennsteg"] = "Zugentlastungstrennsteg";
    IaKind["Zwischenboden"] = "Zwischenboden";
    IaKind["Zwischenlasche"] = "Zwischenlasche";
})(IaKind = exports.IaKind || (exports.IaKind = {}));
//# sourceMappingURL=IaKind.js.map